import {put, takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {TYPES as SIGNUP_TYPE} from '../creators/signup';
import {fetchCurrentUser, TYPES as CURRENT_USER_TYPE} from '../creators/currentUser';

import {RULES_RESET, RULES_SET} from '../reducers2/rules';
import history from "../libs/history";


export function* createSuccess(action) {
    try {

        yield put({type: RULES_SET, rules: action.payload.rules});
        if (action.payload && action.payload.rules) {
            delete action.payload.rules;
        }
        if (action.payload && action.payload.token) {
            delete action.payload.token;
        }

        // yield put({type: CURRENT_USER_TYPE.SUCCESS_ONE, payload: action.payload});
        fetchCurrentUser();
        history.push('/first-connexion');
    } catch (error) {
        console.log(error, "error");
        // yield put({type: LOGIN_USER_ME_FAIL, payload: action.payload.rules});
    }
}

export function* fetchFail(action) {
    try {
        yield put({type: RULES_RESET});
        yield put({type: CURRENT_USER_TYPE.RESET});
        yield put(localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME));
    } catch (error) {
        // yield put({type: LOGIN_USER_ME_FAIL, payload: action.payload.rules});
    }
}

export function* watchSignup() {
    yield takeEvery(SIGNUP_TYPE.CREATE_SUCCESS, createSuccess);
}

export default watchSignup;